import React from 'react'
import {isFunction} from 'lodash'

const withPropsPresent = (Component, expectedProps = []) => {
  return (props) => {
    expectedProps = expectedProps.map(ep => {
      if (!isFunction(ep)) {
        return (props) => !!props[ep]
      }
      return ep
    })
    if (expectedProps.length && !expectedProps.every(ep => !!ep(props))) {
      return null
    }
    return (<Component {...props}/>)
  }
}

export {withPropsPresent}

export default withPropsPresent